export const CompanyAccountEmail = 'admin@digitalshield.com';


export const notifictation = {
    User: {
        contract_verified: "Congratulazione, il tuo contratto è attivo",
        contract_in_scadenza: "Contratto in scadenza",
    },
    Commerciale: {

    },
    Admin: {}

}

export const Roles = {
    ADMIN: {
        displayName: 'Administrator',
        capital: 0,
    },
    ADVISOR: {
        displayName: 'Advisor',
        capital: 0,
    },
    CLIENT: {
        displayName: 'Client',
        capital: 0,
    },

    // actual brokers
    EXECUTIVE_ADVISOR: {
        displayName: 'Executive Advisor',
        capital: 5000,
    },
    SENIOR_ADVISOR: {
        displayName: 'Senior Advisor',
        capital: 10000,
    },
    LEADER_ADVISOR: {
        displayName: 'Leader Advisor',
        capital: 30000,
    },
    EXECUTIVE_MANAGER: {
        displayName: 'Executive Manager',
        capital: 60000,
    },
    SENIOR_MANAGER: {
        displayName: 'Senior Manager',
        capital: 120000,
    },
    LEADER_MANAGER: {
        displayName: 'Leader Manager',
        capital: 250000,
    },
    EXECUTIVE_DIRECTOR: {
        displayName: 'Executive Director',
        capital: 500000,
    },
    SENIOR_DIRECTOR: {
        displayName: 'Senior Director',
        capital: 750000,
    },
    LEADER_DIRECTOR: {
        displayName: 'Leader Director',
        capital: 1000000,
    },
};

export const CommercialRoles = {


    // actual brokers
    EXECUTIVE_ADVISOR: {
        displayName: 'Executive Advisor',
        capital: 5000,
    },
    SENIOR_ADVISOR: {
        displayName: 'Senior Advisor',
        capital: 10000,
    },
    LEADER_ADVISOR: {
        displayName: 'Leader Advisor',
        capital: 30000,
    },
    EXECUTIVE_MANAGER: {
        displayName: 'Executive Manager',
        capital: 60000,
    },
    SENIOR_MANAGER: {
        displayName: 'Senior Manager',
        capital: 120000,
    },
    LEADER_MANAGER: {
        displayName: 'Leader Manager',
        capital: 250000,
    },
    EXECUTIVE_DIRECTOR: {
        displayName: 'Executive Director',
        capital: 500000,
    },
    SENIOR_DIRECTOR: {
        displayName: 'Senior Director',
        capital: 750000,
    },
    LEADER_DIRECTOR: {
        displayName: 'Leader Director',
        capital: 1000000,
    },
};


export const Percentages = {
    BASE: 7,

    ON_CAPITAL: {
        '1000': 0.5,
        '10000': 1,
        '20000': 1.5,
        '35000': 2,
        '50000': 2.5,
        '75000': 3,
        '100000': 3.5,
    },

    ON_YEARS: {
        '1': 0.5,
        '2': 1,
        '3': 1,
        '4': 1.5,
        '5': 1.5,
    },

    ON_ROLE: {
        'Executive Advisor': 50,
        'Senior Advisor': 55,
        'Leader Advisor': 60,
        'Executive Manager': 65,
        'Senior Manager': 70,
        'Leader Manager': 75,
        'Executive Director': 80,
        'Senior Director': 85,
        'Leader Director': 90,
    },
};


export const ContractStatus = {
    DRAFT: 'Bozza',
    TOVERIFY: "Da Verificare",
    TOBEPAYED: "Da Bonificare",
    PAYED: 'Bonificato',
    ACTIVE: 'Attivo',
};

export const FaqCategory = {
    introduzione_aziendale: '1. Introduzione Aziendale ',
    Procedura_KYC: '2. Procedura KYC',
    Legalita_fiscalita: '3. Legalità e Fiscalità',
    spendibilita: '4. Spendibilità',
    Custodia_Gestione: '5. Custodia e Gestione',
    criptovalute_blockchain: '6. Criptovalute e Blockchain',
    Safety_Shield: '7. Safety Shield',
    Supporto_Assistenza: '8. Supporto e Assistenza',
    Moduli_Documentazioni: '9. Moduli e Documentazioni',

};
